import $ from 'jquery';
import { tns } from 'tiny-slider/src/tiny-slider';
import { uploadVideos } from './camps/show/video';
import { updateBonuses } from './certificates';
import { MTUIGetElement, MTUIOnInit } from './mtui/mtui';

$(document).ready(function () {
  initCampsSlider();
  uploadVideos();
  MTUIOnInit(() => {
    MTUIGetElement('certificate_amount')?.change((amount) => {
      if (amount === 'another') {
        $('.bonuses-block').hide();
      } else {
        updateBonuses(amount);
        $('.bonuses-block').show();
      }
      $('#certificate_link').attr('href', `/certificates/new?amount=${amount}`);
    });
  });
});

function initCampsSlider() {
  const $sliderContainer = $('.gift-page-section .slider-tns');
  const $sliderControls = $('.gift-page-section .slider-tns__arrows');

  if (!$sliderContainer.length || !$sliderControls.length) {
    return;
  }

  const sliderTns = tns({
    container: $sliderContainer[0],
    mode: 'carousel',
    items: 3,
    controls: true,
    controlsContainer: $sliderControls[0],
    nav: false,
    axis: 'horizontal',
    startIndex: 0,
    slideBy: 'page',
    mouseDrag: false,
    lazyload: true,
    loop: false,
    gutter: 23,
    lazyloadSelector: '.tns-lazy-img',
  });

  if (!sliderTns) return;

  sliderTns.events.on('indexChanged', () => {
    const info = sliderTns.getInfo();
    const { index, slideCount } = info;
    $sliderControls.find('.slider-tns__thumb-arrow-left').toggle(index !== 0);

    $sliderControls.find('.slider-tns__thumb-arrow-right').toggle(index !== slideCount - 3);
  });
}
